import { CEInvoiceBase } from './ce-invoice-base'


export class CEInvoice extends CEInvoiceBase {

}